import styled from 'styled-components';

import ModalWrapper from 'dashboard/components/ModalWrapper';
import FormGraphQueryTemplateLoad, {
  FormGraphQueryTemplateLoadData,
} from 'dashboard/forms/FormGraphQueryTemplateLoad';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';

interface TemplateLoadModalProps {
  isTemplateLoadModalOpen: boolean;
  handleCloseModal: () => void;
  onSubmit: (data: FormGraphQueryTemplateLoadData) => void;
}
const ModalContainerOverflowable = styled(ModalContainer)`
  overflow-y: visible;
`;
const ModalBodyOverflowable = styled(ModalBody)`
  overflow-y: visible;
`;
const TemplateLoadModal = ({
  isTemplateLoadModalOpen,
  handleCloseModal,
  onSubmit,
}: TemplateLoadModalProps) => {
  return (
    <ModalWrapper
      isOpen={isTemplateLoadModalOpen}
      handleCloseModal={handleCloseModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainerOverflowable data-test='graph-explorer__template-load-modal'>
        <ModalHeader
          data-test='graph-explorer__template-load-modal__header'
          onClose={handleCloseModal}
        >
          Load
        </ModalHeader>
        <ModalBodyOverflowable>
          <FormGraphQueryTemplateLoad onSubmit={onSubmit} />
        </ModalBodyOverflowable>
      </ModalContainerOverflowable>
    </ModalWrapper>
  );
};

export default TemplateLoadModal;
